export default "__VITE_ASSET__98163888__"